const firebase = require("firebase");
// Required for side-effects
require("firebase/firestore");

const config = {
  apiKey: "AIzaSyCF9BLTBGgXzsMZdr_Shj5rqwI2MrLTe_o",
  authDomain: "neal-fun.firebaseapp.com",
  databaseURL: "https://neal-fun.firebaseio.com",
  projectId: "neal-fun",
  storageBucket: "neal-fun.appspot.com",
  messagingSenderId: "936689335295"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const twitterProvider = new firebase.auth.TwitterAuthProvider();
export const facebookProvider = new firebase.auth.FacebookAuthProvider();
export const auth = firebase.auth();
export const db = firebase.firestore();



// WEBPACK FOOTER //
// ./src/firebase/firebase.js